export const auction = {
  name: 'Name',
  startDate: 'Datum / Uhrzeit',
  status: 'Status',
  statusOpen: 'Gleich'
}
